import BigNumber from 'bignumber.js'
import { useMemo } from 'react'
import { formatUsdValue } from '../utils/formatUsdValue'
import { useCollateralById } from './useCollateralById'

export const useUsdValue = ({ value, collateralId, withPlus, withAbout, simplifyFormat }: Params) => {
  const collateral = useCollateralById(collateralId)

  const multiplier = collateral?.multiplier ?? 1
  const valueUsd = useMemo(() => new BigNumber(value).dividedBy(multiplier || 1), [value, multiplier])

  const usd = valueUsd.toNumber()
  const usdFormatted = formatUsdValue(valueUsd, withPlus, withAbout, undefined, undefined, simplifyFormat)

  return { usd, usdFormatted }
}

export default useUsdValue

interface Params {
  value: number
  collateralId: number | undefined
  withPlus?: boolean
  withAbout?: boolean
  simplifyFormat?: boolean
}
